/**
 * @description ตรวจสอบว่า DevTools กำลังเปิดใช้งานอยู่หรือไม่ โดยใช้การตรวจสอบขนาดหน้าต่าง
 * (เทคนิคนี้ใช้การตรวจสอบความแตกต่างระหว่างขนาดหน้าต่างภายนอกและภายใน)
 *
 * @returns {boolean} คืนค่า true หากตรวจพบว่า DevTools เปิดอยู่,
 * และคืนค่า false หาก DevTools ปิดอยู่
 */
export const isDevToolsOpen = async () => {
  // กำหนดเกณฑ์ (pixels) สำหรับความแตกต่างของขนาด
  // ค่า 160 pixels เป็นค่าที่นิยมใช้และค่อนข้างเชื่อถือได้
  const threshold = 160;

  // window.outerWidth คือความกว้างรวมของหน้าต่างเบราว์เซอร์
  // window.innerWidth คือความกว้างของพื้นที่เนื้อหา (Viewport)
  // เมื่อ DevTools ถูก "Docked" (แนบ) เข้ากับหน้าต่างหลัก
  // ความแตกต่างระหว่าง outerWidth/Height และ innerWidth/Height จะมีค่าสูงขึ้นอย่างเห็นได้ชัด
  const widthDifference = window.outerWidth - window.innerWidth;
  const heightDifference = window.outerHeight - window.innerHeight;

  // ถ้าความแตกต่างของความกว้าง หรือ ความสูง มีมากกว่าเกณฑ์
  return widthDifference > threshold || heightDifference > threshold;
};
